import axios from 'axios';

const client = axios.create({
  baseURL: "https://www.careplus.gopillz.com/"
});

export default client;